









































































































import mixins from 'vue-typed-mixins'
import PMNAdministrationMixin from './PMNAdministrationMixin'
import { ListeTypeInput, TypeInput } from '@/domain/PMNModele'

export default mixins(PMNAdministrationMixin).extend({
    data() {
        return {
            headers: [
                { text: 'Nom', value: 'nom' },
                { text: 'Date de création', value: 'dateCreation' },
                { text: 'Actions', value: 'action', align: 'end' }
            ],
            listeTypeInput: ListeTypeInput,
            typeInputProposition: TypeInput.ListeProposition,
            typeInputDate: TypeInput.Date,
            tab: null
        }
    }
})
